import React from "react";
import { Badge } from "@/components/ui/badge";
import type { AgreementStatus } from "@/types/agreement";

export const AGREEMENT_STATUS_LABELS: Record<AgreementStatus, string> = {
  DRAFT: "Draft",
  IN_REVIEW: "In Review",
  APPROVED: "Approved",
  SENT: "Sent",
  VIEWED: "Viewed",
  PARTIALLY_SIGNED: "Part-signed",
  EXECUTED: "Executed",
  DECLINED: "Declined",
  EXPIRED: "Expired",
  TERMINATED: "Terminated",
  SUPERSEDED: "Superseded",
};

const VARIANTS: Record<AgreementStatus, "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "blue"> = {
  DRAFT: "secondary",
  IN_REVIEW: "warning",
  APPROVED: "blue",
  SENT: "default",
  VIEWED: "default",
  PARTIALLY_SIGNED: "warning",
  EXECUTED: "success",
  DECLINED: "destructive",
  EXPIRED: "destructive",
  TERMINATED: "destructive",
  SUPERSEDED: "outline",
};

export function AgreementStatusBadge({ status }: { status: AgreementStatus }) {
  return <Badge variant={VARIANTS[status] || "outline"}>{AGREEMENT_STATUS_LABELS[status] || status}</Badge>;
}
